<template>
  <div class="tab__content">
    <div class="tournament__filter  container fluid grid-list-lg px-0">
      <div class="layout row wrap align-center">
        <div
          class="flex xs12 sm8 md9 order-xs2 order-sm1 tournament__filter_categories"
        >
          <!-- <app-btn round color="dark-blue-grad">Результаты</app-btn>
          <app-btn round color="dark-blue-grad">Записи</app-btn> -->
        </div>
        <div
          class="flex xs12 sm4 md3 order-xs1 order-sm2 tournament__filter_search"
        >
          <div class="text-field text-field_round text-field_dark-blue">
            <div class="text-field__slot">
              <input v-model="query" type="text" placeholder="Поиск" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tournament__members container fluid grid-list-lg px-0">
      <div
        class="tournament__members_list layout row wrap"
        v-if="players.length"
      >
        <div
          v-for="(player, n) in players"
          :key="player.id"
          class="flex xs12 sm4 md3"
        >
          <app-btn
            target="_blank"
            :href="
              (player &&
                player.steam_id64 &&
                `https://steamcommunity.com/profiles/${player.steam_id64}/`) ||
                null
            "
            class="tournament__member"
          >
            <div
              class="tournament__member__ava grow-shrink-0"
              :class="{
                tournament__member__ava_red: n % 2 == 0,
                tournament__member__ava_blue: n % 2 != 0
              }"
            >
              <img v-if="player.avatar" :src="player.avatar" alt="avatar" />
              <SvgIcon v-else size="80%" name="user-light" />
            </div>
            <div class="tournament__member__info">
              <div class="tournament__member_name ellipsis">
                {{ player.nickname }}
              </div>
              <div class="tournament__member_country ellipsis">
                {{ player.country | country }}
              </div>
            </div>
          </app-btn>
        </div>
      </div>
      <div
        ref="gamesList"
        class="tournament__members_list tournament__members_list-empty layout row wrap"
        v-else-if="!loading && !players.length"
      >
        <div class="flex xs12">
          <div class="tournament__member py-4 text-xs-center">
            Список участников пуст
          </div>
        </div>
      </div>
    </div>
    <app-paginator
      v-if="pagination && pagination.pageCount > 1"
      v-model="pagination.currentPage"
      :page-count="pagination.pageCount"
      :click-handler="fetchPageData"
      class="layout row align-center justify-center"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
import tournamentsService from "@/services/tournaments";
import AppPaginator from "@/components/ui/pagination/AppPaginator";

export default {
  components: { AppPaginator },
  data: () => ({
    loading: false,
    query: "",
    players: [],
    pagination: {},
    page: 1
  }),

  watch: {
    routeParams: "fetchPageData",
    isParticipant: function() {
      this.fetchPageData(this.page);
    },
    query: debounce(function() {
      this.fetchPageData(1);
    }, 300)
  },

  computed: {
    ...mapGetters(["routeParams"]),
    ...mapGetters("tournaments", ["tournament", "participation"]),

    isParticipant() {
      return this.participation.includes(this.tournament.id || 0);
    }
  },

  sockets: {
    notification(message) {
      const isAllowed = ["matches_performed", "tournament_changed"].includes(
        message.type
      );
      const onCurTournament =
        this.routeParams.tournament_id === message.tournament_id;

      if (isAllowed && onCurTournament) {
        this.fetchPageData(this.pagination.currentPage);
      }
    }
  },

  methods: {
    async fetchPageData(page) {
      if (this.loading) return;
      this.loading = true;
      let params = {
        "per-page": 32
      };

      if (page) {
        params.page = page;
      }

      if (this.query && this.query.length) {
        params.query = this.query;
      }

      let { players, ...pagination } = await tournamentsService.getPlayers(
        this.routeParams.tournament_id,
        { params }
      );
      this.players = players;
      this.pagination = pagination;

      this.loading = false;
      this.$store.dispatch("tournaments/updateTournament");
    }
  },

  created() {
    this.fetchPageData();
  }
};
</script>
